/**
 * @generated SignedSource<<30c1c39ef824e1c965e7b88615cc3dff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSection_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionText_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionBanner_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionParticipativeModulesList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionEventsList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionCalendar_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionActorsList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionPagesList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionFilesList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionFeaturedContent_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarText_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarLinkBlock_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarUsersGroupRequestLinkBlock_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionEmbed_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionParticipativeModuleResults_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionMap_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSearchBox_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionAnalyticsDataList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarFilesList_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarBanner_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionMapElementFeatureAttribute_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionCookiesConsentsConfiguration_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSitemap_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionInformationSearch_pageSection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSectionSidebarEventsList_pageSection"
    }
  ],
  "type": "PageSectionBase",
  "abstractKey": "__isPageSectionBase"
};

node.hash = "34b14eb02409aeb47026607174ae024b";

module.exports = node;
